// Hợp đồng output máy-đọc-được cho mọi lệnh có cờ `--json` (T5 của epic #247).
//
// VÌ SAO CÓ FILE NÀY: extension VSCode render panel từ output CLI. Parse text log
// là đường bị cấm — text đổi lúc nào không ai biết, panel hỏng lặng. Hợp đồng dưới
// đây là nơi DUY NHẤT định nghĩa luật chung, để 3 lệnh của T5 (và mọi `--json` về
// sau) không mỗi nơi một kiểu.
//
// 4 luật bất biến:
//   1. `--json` là cờ DUY NHẤT bật chế độ máy đọc — không đẻ `--format`/`--porcelain`.
//   2. Mỗi payload mang `schema_version` để phía đọc kiểm và báo "cần nâng cấp CLI"
//      thay vì đoán mò khi shape đổi.
//   3. BÍ MẬT KHÔNG BAO GIỜ vào JSON. Token/API key/PAT chỉ được phơi dưới dạng
//      trạng thái (`has_token: true`, `expires_in_hours: 6`). Output này bị máy khác
//      đọc và có thể bị log lại — coi như public.
//   4. Ở chế độ `--json`, stdout CHỈ chứa đúng 1 dòng JSON. Mọi log người-đọc phải
//      đi stderr, nếu không JSON không parse được.
//
// ⚠️ `--version` là cờ toàn cục của commander — lệnh con KHÔNG được đặt option tên
// `--version` (tiền lệ: `sync` dùng `--pack-version`). Xem ghi chú `index.ts:50-51`.

/**
 * Version của hợp đồng JSON. Tăng khi shape đổi theo hướng KHÔNG tương thích ngược
 * (đổi tên field, bỏ field, đổi kiểu). Thêm field mới thì GIỮ NGUYÊN số này.
 */
export const JSON_SCHEMA_VERSION = 1;

/** Payload nào cũng mang `schema_version` — kiểu này ép điều đó ở tầng compile. */
export type MachineReadablePayload = Record<string, unknown>;

/**
 * In payload ra stdout đúng luật 2 + luật 4: kèm `schema_version`, đúng một dòng
 * JSON, không màu, không viền, không log lẫn vào.
 *
 * Dùng `JSON.stringify` 1 dòng (không pretty-print) vì phía đọc là máy: 1 dòng
 * cho phép stream-parse và không bị lẫn khi ai đó pipe qua `head`.
 */
export function writeMachineReadableJson(payload: MachineReadablePayload): void {
  // `schema_version` đặt trước để đọc log dễ, rồi GÁN LẠI sau spread: caller lỡ mang
  // theo field cùng tên cũng không ghi đè được version của hợp đồng — phía đọc dựa
  // vào con số này để quyết định "có hiểu payload không", nó phải do đây quyết.
  const body = { schema_version: JSON_SCHEMA_VERSION, ...payload };
  body.schema_version = JSON_SCHEMA_VERSION;
  process.stdout.write(`${JSON.stringify(body)}\n`);
}

/**
 * Lỗi dùng-sai-cờ ở chế độ máy đọc: phía gọi là extension, không phải người —
 * nên lỗi cũng phải máy đọc được, ra stderr (luật 4), và exit ≠ 0 do caller lo.
 */
export function writeMachineReadableError(command: string, message: string): void {
  process.stderr.write(
    `${JSON.stringify({ schema_version: JSON_SCHEMA_VERSION, command, error: message })}\n`,
  );
}
